<template>
  <div class="tag-detail">
    <div class="hero">
      <img :src="tagHero">
      <div class="wrap">
        <div class="content">
          <span class="btn-decorated">{{ tag }}</span>
        </div>
      </div>
    </div>

    <b-container class="results-container">
      <DiscoverTabs></DiscoverTabs>
    </b-container>

    <b-container class="results-container">

      <DiscoverResults :tag="tag" v-if="tag"></DiscoverResults>

    </b-container>
  </div>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .tag-detail {
    .results-container {
      @include media-breakpoint-down(sm) {
        padding: 0;
      }
      .container {
        @include media-breakpoint-down(sm) {
          padding: 0;
        }
      }
    }
  }
  .hero {
    margin: 0 -15px 1em -15px;
    position: relative;

    img {
      width: 100%;
      object-fit: cover;
      opacity: 0.7;
    }

    .wrap {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 2;
      display: flex;
      flex-direction: column;
      justify-content: center;
      background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 50%, $body-bg);

      .content {
        font-family: 'AvenirMedium';
        text-align: center;

        span {
          font-size: 2em;
          padding: 0.25em 1em 0.25em 1em;
          @include media-breakpoint-down(xs) {
            font-size: 1.2em;
          }

          &:before {
            content: ' ';
            border: solid 2px $darkish-pink-two;
          }

        }
      }
    }
  }
</style>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import DiscoverTabs from '@/components/widgets/DiscoverTabs'
import DiscoverResults from '@/components/widgets/DiscoverResults'

import { getHero } from '@/store/modules/tag'

export default {
  name: 'Discover',
  components: {
    FontAwesomeIcon,
    DiscoverTabs,
    DiscoverResults
  },
  data () {
    return {
      artists: null,
      albums: null,
      videos: null,
      playlists: null,
      q: '',
      query: null
    }
  },
  computed: {
    tagHero () {
      return getHero(this.type, this.tag)
    },
    type () {
      return this.$route.meta.type
    },
    tag () {
      return this.$route.params.tag
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/discover/TagDetail.vue